import { render, staticRenderFns } from "./index.vue?vue&type=template&id=eb56050e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=eb56050e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb56050e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/data/.jenkins/workspace/yyWebsite/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb56050e')) {
      api.createRecord('eb56050e', component.options)
    } else {
      api.reload('eb56050e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=eb56050e&scoped=true&", function () {
      api.rerender('eb56050e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wisdomStore/index.vue"
export default component.exports